import React, { ReactElement, useCallback, useState, forwardRef, useEffect, useRef } from 'react';
import { useGetDetailDataSimple } from '@/page/detail/views/api';
import Toast from '@/component/Toast/Toast';
import { $k18n } from '@/common/i18n';
import SpecLinePop from '@/page/detail/views/content/components/SpecLinePop';
import { CartItem } from './api';
import { allowDefaultOutsideClick, ignoreOutsideClick, onClickContainerOutside } from '@/common/utils/clickOnContinerOutSide';
import { getEncryptionFormat } from '@/common/api-for-decode-base';

type IProps = {
    showPop: boolean;
    curPopItem: CartItem;
    closePop: () => void;
    openHalfConfirmOrder?: boolean;
    showAfterCouponPrice?: boolean;
    scene?: number;
};

/**
 * 规格弹窗
 */
const SpecPop = forwardRef(function SpecPop(props: IProps): ReactElement {
    const [showSpec, setShowSpec] = useState(false);
    const [pageRawData, setPageRawData] = useState(null);

    const { showPop = false, closePop, curPopItem = { commodityId: 0 }, showAfterCouponPrice = false } = props;

    const [DetailPageStore, setDetailPageStore] = useState({
        immediateAvailableQuantity: 1, // 动态库存 伴随勾选规格而变化
    });

    useEffect(() => {
        // 秒杀商品部分sku库存为0
        if (
            pageRawData?.activityInfo?.activityId &&
            [2, 4, 5].includes(pageRawData?.activityInfo?.status) &&
            DetailPageStore &&
            DetailPageStore?.immediateAvailableQuantity === 0
        ) {
            Toast.show({
                text: $k18n({ id: 'sku_0_activity_stock', text: '抱歉，该规格的活动库存为0' }),
                duration: 1000,
            });
            return;
        }
    }, [DetailPageStore]);

    const closeSpec = () => {
        setShowSpec(false);
        allowDefaultOutsideClick();
        closePop();
    };

    const { getDetailDataSimple, data: detailDataRes } = useGetDetailDataSimple({
        itemId: curPopItem?.commodityId,
        encryptedParam: JSON.stringify(getEncryptionFormat()), // 不能JSON.stringify, 预请求参数需要和这里一致
        sellerUserId: Number(curPopItem?.sellerMerchantId || 0),
        merchantId: Number(curPopItem?.sellerMerchantId || 0),
        scene: props.scene || 0,
    });

    // 获取商品详情，拿到规格数据

    useEffect(() => {
        if (detailDataRes?.data) {
            const detailDataResData = detailDataRes.data;
            // 秒杀商品整体限购
            if (detailDataResData?.activityInfo?.activityId && detailDataResData?.activityInfo?.status === 4) {
                Toast.show({ text: $k18n({ id: 'k_406982', text: '抱歉，您已达活动购买上限，去看看其他商品' }) });
            }
            setPageRawData(detailDataResData);
            // if (detailDataResData.skus.length > 1) {
            //     console.log('sku num error');
            //     return;
            // }
            setShowSpec(true);
            ignoreOutsideClick();
            onClickContainerOutside(() => {
                closeSpec();
            });
        }
    }, [detailDataRes]);

    useEffect(() => {
        if (curPopItem?.commodityId > 0 && showPop) {
            if (curPopItem?.commodityId === detailDataRes?.data?.itemId) setPageRawData(detailDataRes?.data);
            getDetailDataSimple();
        }
    }, [showPop, curPopItem?.commodityId]);

    return (
        <>
            <SpecLinePop
                type="buy"
                showDetailUrl={curPopItem?.jumpUrl}
                isPopVisible={showSpec}
                pageRawData={pageRawData}
                closeSpec={closeSpec}
                showAfterCouponPrice={showAfterCouponPrice}
                openHalfConfirmOrder={true}
            />
        </>
    );
});

export default SpecPop;
